import { ScoredCreditCardProduct } from '@ilg-totallymoney/types'

function getBalanceTransferOfferDurationMonths(
    creditCard: ScoredCreditCardProduct
) {
    return (
        creditCard.balanceTransferOfferDurationMonths ??
        creditCard.offerDetail.durationOfBalanceRateMonths
    )
}

export default getBalanceTransferOfferDurationMonths
